<div class="card-white">
  <div class="card-header mb-4" *ngIf="modoActividad">
    <div class="title-section">
        <h2 class="header-title">Centro de Mensajes</h2>
    </div>
    <div class="button-section">
        <button mat-flat-button class="btn-delete" (click)="Close()" appPermissionControl="P008B0004">
            <mat-icon>close</mat-icon> Cerrar
        </button>
    </div>
</div>
  <!-- Formulario de envío de mensajes -->
  <div>
    <div>
      <div class="d-flex gap-1">
        <div class="form-field flex-grow-1">
          <p-dropdown
            [options]="perfilesDropdown"
            [(ngModel)]="selectedPerfil"
            optionLabel="label"
            optionValue="value"
            [filter]="true"
            [showClear]="true"
            placeholder="Seleccione Perfil"
            class="w-100"
            [disabled]="isPerfilDisabled"
            (onChange)="onPerfilChange($event)"
            appPermissionControl="P008K0001"
          >
            <ng-template let-perfil pTemplate="item">
              <div class="dropdown-item">{{ perfil.label }}</div>
            </ng-template>
          </p-dropdown>
          <label>Perfil</label>
        </div>
      </div>
      <div class="form-field">
        <p-dropdown
          [options]="usuarios"
          [(ngModel)]="selectedUsuario"
          optionLabel="nombreusuario"
          optionValue="susuario"
          [filter]="true"
          [showClear]="true"
          placeholder="Seleccione Usuario"
          class="w-100"
          [disabled]="isUsuarioDisabled"
          (onChange)="onUsuarioChange($event)"
          appPermissionControl="P008K0002"
        >
          <ng-template let-usuario pTemplate="item">
            <div class="dropdown-item">{{ usuario.nombreusuario }}</div>
          </ng-template>
        </p-dropdown>
        <label>Usuario</label>
      </div>
    </div>

    <div class="form-row mt-3">
      <div class="form-field">
        <div class="position-relative">
          <textarea rows="6" class="form-control" [(ngModel)]="mensaje" style="min-height: 150px" appPermissionControl="P008K0003"></textarea>
          <p-button
            icon="pi pi-image"
            [disabled]="true"
            styleClass="p-button-rounded p-button-text p-button-info"
            class="position-absolute"
            style="top: 4px; right: 4px"
            pTooltip="Imágenes"
            appPermissionControl="P008B0001"
          ></p-button>
          <p-button
            label="Enviar"
            icon="pi pi-arrow-right"
            iconPos="right"
            styleClass="p-button-info"
            class="position-absolute"
            style="bottom: 4px; right: 4px"
            (onClick)="enviarMensaje()"
            appPermissionControl="P008B0002"
          ></p-button>
        </div>
      </div>
    </div>

    <!-- Filtros de búsqueda -->
    <div>
      <div>
        <div class="button-date mb-4">
          <div>
            <p-calendar
              [(ngModel)]="fechaDesde"
              placeholder="Seleccione Fecha"
              [showIcon]="true"
              [iconDisplay]="'input'"
              inputId="icondisplay"
              dateFormat="dd/mm/yy"
              [readonlyInput]="true"
            >
            </p-calendar>
          </div>
          <button mat-flat-button class="btn-new" (click)="buscarMensajes()" appPermissionControl="P008B0003">
            <mat-icon>search</mat-icon>
            Buscar
          </button>
        </div>

        <div>
          <p-selectButton [options]="tiposMensaje" [(ngModel)]="tipoSeleccionado" optionLabel="label" optionValue="value" (onChange)="buscarMensajes()"></p-selectButton>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabla de mensajes -->
  <div class="card-body">
    <p-table
      #dt
      [value]="mensajes"
      [columns]="columns"
      [paginator]="true"
      [rows]="10"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 20, 40]"
      [scrollable]="true"
      [scrollHeight]="'calc(100vh - 400px)'"
      styleClass="p-datatable-gridlines"
      [resizableColumns]="true"
      [autoLayout]="true"
      responsiveLayout="scroll"
      [loading]="loading"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      appPermissionControl="P008T0001"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" class="th-prime" appPermissionControl="P008C0001">
            {{ col.header }}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr>
          <td *ngFor="let col of columns" class="td-prime">
            <ng-container [ngSwitch]="col.field">
              <ng-container *ngSwitchCase="'fechalectura'">
                {{ tipoSeleccionado === 'enviados' ? rowData.fechalectura : rowData.defecha }}
              </ng-container>
              <ng-container *ngSwitchCase="'horalectura'">
                {{ tipoSeleccionado === 'enviados' ? rowData.horalectura : rowData.dehora }}
              </ng-container>
              <ng-container *ngSwitchDefault>
                {{ rowData[col.field] }}
              </ng-container>
            </ng-container>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="columns.length" class="text-center td-prime">No hay mensajes para mostrar</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<style>
  /* Estilos para los botones */
  :host ::ng-deep .p-button.p-button-text {
    background: transparent;
    color: var(--primary-color);
    padding: 0.5rem 1rem;
  }

  :host ::ng-deep .p-button.p-button-text:hover {
    background: rgba(var(--primary-color-rgb), 0.04);
  }

  :host ::ng-deep .p-button.p-button-text:disabled {
    background: transparent;
    color: var(--primary-color);
    opacity: 0.6;
  }

  :host ::ng-deep .p-button.p-button-info {
    background: var(--primary-color);
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 6px;
  }

  :host ::ng-deep .p-button .p-button-icon {
    font-size: 1rem;
  }

  :host ::ng-deep .p-button .p-button-label {
    font-size: 0.875rem;
    font-weight: 500;
  }

  /* Estilos para el textarea */
  textarea.form-control {
    resize: none;
  }

  /* Estilos para los inputs de fecha */
  input[type='date'].form-control {
    height: 32px;
    padding: 0.25rem 0.5rem;
    font-size: 12px;
    width: 100%;
  }

  input[type='date'].form-control::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }

  /* Estilos para el select button */
  :host ::ng-deep .p-selectbutton {
    display: flex;
  }

  :host ::ng-deep .p-selectbutton .p-button {
    background: #ffffff;
    border: 1px solid var(--primary-color);
    color: var(--primary-color);
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
  }

  :host ::ng-deep .p-selectbutton .p-button:first-child {
    border-radius: 6px 0 0 6px;
  }

  :host ::ng-deep .p-selectbutton .p-button:last-child {
    border-radius: 0 6px 6px 0;
  }

  :host ::ng-deep .p-selectbutton .p-button.p-highlight {
    background: var(--primary-color);
    border-color: var(--primary-color);
    color: #ffffff;
  }

  :host ::ng-deep .p-selectbutton .p-button:not(.p-highlight):hover {
    background: rgba(var(--primary-color-rgb), 0.04);
  }
</style>
